<div class="header-bar">
  <div class="header-left">
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <div class="header-text">Flow Report ( {{ report.name }} )</div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="flow-report">
  <div class="container report-container">
    <div class="container-header no-bottom-border">
      <div class="text">Activity</div>
    </div>

    <div class="container-content">
      <table
        #reportTable
        mat-table
        [dataSource]="reportDataSource"
        multiTemplateDataRows
        matSort
      >
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let row">
            {{ formatDate(row.date) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef mat-sort-header># Sent</th>
          <td mat-cell *matCellDef="let row">
            {{ row.total ? row.total : "0" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="detail"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              "
            >
              <div *ngFor="let signal of element.signals" class="signal">
                <div class="sent-to">
                  Sent to
                  {{
                    signal.appDevice?.appUser?.first_name &&
                    signal.appDevice?.appUser?.last_name
                      ? signal.appDevice.appUser.last_name +
                        ", " +
                        signal.appDevice.appUser.first_name
                      : signal.appDevice?.appUser?.email
                  }}
                  at
                  <ng-container *ngIf="signal.sent_on_date">
                    {{ formatDate(signal.sent_on_date) }}
                  </ng-container>
                  <ng-container *ngIf="!signal.sent_on_date">
                    {{ formatDate(signal.created_at) }}
                  </ng-container>
                </div>
                <div class="device-info">
                  {{ signal.appDevice.device.make }}
                  {{ signal.appDevice.device.model }} (
                  {{ signal.appDevice.device.system_name }}
                  {{ signal.appDevice.device.system_version }} )
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="date-row"
          [class.expanded-row]="expandedElement === row"
          (click)="expandedElement = expandedElement === row ? null : row"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
        ></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
  <div class="container icon-info-container conversions-container">
    <div class="container-header no-bottom-border">
      <div class="text">Conversions</div>
    </div>

    <div class="container-content">
      <div class="row">
        <div class="icon">
          <svg-icon src="assets/svg/conversions.svg"></svg-icon>
          <div class="text">{{ conversions ? conversions : "0" }}</div>
        </div>
        <div class="graph">
          <div
            echarts
            [options]="conversionsChartOptions"
            class="bar-chart"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
